export const Colors = {
  red: "#FE4069",
  blue: "#5B77FF",
  green: "#67C259",
  pink: "#EF67E6",
  yellow: "#FFCF4D",
  black: "#000000",
}
